<template>
  <Panel class="mt-10" name="جزئیات">
    <form action="">
      <textarea class="bg-gray-100 w-full rounded-lg p-2"
                placeholder="توضیحات"
      v-model="description"></textarea>

      <Button class="w-full mt-4" @click="submitDetail">ثبت</Button>
    </form>
  </Panel>
</template>

<script>
import Panel from "../../components/Panel";
import Button from "../../components/Button";
export default {
  name: "SurveyDetails",
  components: {Button, Panel},
  data() {
    return {
      description: this.$store.state.survey.detail.description
    }
  },
  methods: {
    submitDetail() {
      let detail = {
       description: this.description
      }
      this.$store.dispatch('setDetail', detail)
    }
  }
}
</script>

<style scoped>

</style>